import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray } from "formik";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { FeatureInfo } from "../../../SchemaInfo/info";
import { FeatureSchema } from "../../../Schemas/featureDocs/featureDocs.schema";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { useNavigate } from "react-router";
import { FcFlowChart } from "react-icons/fc";

const AddFeature = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const rolesList = [
    "publicAccess",
    "superAdmin",
    "purchaseStaff",
    "saleStaff",
    "agronomistStaff",
    "opsStaff",
    "inspectionStaff",
    "marketingStaff",
    "adminStaff",
    "labourStaff",
    "client",
    "demoClient",
    "buyer",
    "vendor",
    "farmerSubscriber",
    "salesAgency",
    "leftSaleStaff",
    "accountStaff",
    "ITStaff",
    "internal",
    "SMMStaff",
    "salesManager",
    "clientFeedback",
    "siteInspection",
    "farmer partner",
    "cnf",
    "Jr.HR",
    "HR",
    "salesAdmin",
  ];

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) =>
        setUsers(
          res?.data?.filter(
            (user) =>
              user.role === "ITStaff" ||
              user.role === "superAdmin" ||
              user.role === "adminStaff"
          )
        )
      )
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handelSubmit = (values, actions) => {
    setLoading(true);
    performRequest("POST", "/features/createFeatures", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Feature added successfully!");
          navigate(`/feature-docs`);
        } else {
          Toast("error", "Error while uploading feature");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) return <LoadingPage />;

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">
                    <FcFlowChart className="fs-2 me-1" />
                    Feature Docs
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
            <div className="card my-4">
              <div className="card-header">
                <h2 className="page-title">Add New Feature</h2>
              </div>

              <Formik
                initialValues={FeatureInfo}
                validationSchema={FeatureSchema}
                onSubmit={handelSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      {console.log(props)}
                      <div className="mb-3 row">
                        <label className="col-3 form-label required">
                          Feature
                        </label>
                        <div className="col">
                          <CustomInput name="feature" />
                          {props.touched.feature && props.errors.feature && (
                            <p className="text-danger">
                              {props.errors.feature}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="col-3 form-label">Description</label>
                        <div className="col">
                          <CustomTextArea name="description" />
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Access Roles
                        </label>
                        <div
                          className="w-100 col border m-2 p-2"
                          style={{ maxHeight: "150px", overflow: "scroll" }}
                        >
                          {rolesList.map((role, index) => (
                            <div key={index}>
                              <div className="d-flex">
                                <label className="form-check-inline">
                                  <CustomCheckbox
                                    type="checkbox"
                                    width="15px"
                                    height="15px"
                                    name="accessRoles"
                                    value={role}
                                  />
                                </label>
                                <span className="form-check-label">{role}</span>
                              </div>
                            </div>
                          ))}

                          {props.touched.accessRoles &&
                            props.errors.accessRoles && (
                              <p className="text-danger">
                                {props.errors.accessRoles}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-3 form-label">Status</label>
                        <div className="col">
                          <CustomSelect name="status">
                            <option value="">Select</option>
                            <option value="inprocess">In Process</option>
                            <option value="testing">Testing</option>
                            <option value="deployed">Deployed</option>
                            <option value="under review">Under Review</option>
                            <option value="completed">Completed</option>
                          </CustomSelect>
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="col-3 form-label">Conditions</label>
                        <div className="col">
                          <CustomTextArea name="conditions" />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-3 form-label">Access route</label>
                        <div className="col">
                          <CustomInput name="accessRoute" />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-3 form-label">Design by</label>
                        <div className="col">
                          <CustomSelect name="designBy">
                            <option value="">Select</option>
                            {users?.map((user) => (
                              <option key={user._id} value={user.nameName}>
                                {user.userName}
                              </option>
                            ))}
                          </CustomSelect>
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-3 form-label">Develope by</label>
                        <div className="col">
                          <CustomSelect name="developBy">
                            <option value="">Select</option>
                            {users?.map((user) => (
                              <option key={user._id} value={user.nameName}>
                                {user.userName}
                              </option>
                            ))}
                          </CustomSelect>
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-3 form-label">Backend by</label>
                        <div className="col">
                          <CustomSelect name="backendBy">
                            <option value="">Select</option>
                            {users?.map((user) => (
                              <option key={user._id} value={user.nameName}>
                                {user.userName}
                              </option>
                            ))}
                          </CustomSelect>
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-3 form-label">
                          Additional Notes
                        </label>
                        <div className="col">
                          <CustomTextArea name="notes" />
                        </div>
                      </div>

                      {/* Newly Updates */}
                      <FieldArray name="newlyUpdates">
                        {({ push, remove }) => (
                          <div>
                            <hr />
                            <h3>Newly Updates</h3>
                            <hr />
                            {props.values.newlyUpdates.map((update, index) => (
                              <div
                                key={index}
                                className="mb-2 row g-3 align-items-center"
                              >
                                <div className="col-md">
                                  <CustomInput
                                    name={`newlyUpdates[${index}].update`}
                                    placeholder="Update"
                                  />
                                </div>
                                <div className="col-md-2">
                                  <CustomSelect
                                    name={`newlyUpdates[${index}].updatedBy`}
                                  >
                                    <option value="">Updated By</option>
                                    {users?.map((user) => (
                                      <option
                                        key={user._id}
                                        value={user.nameName}
                                      >
                                        {user.userName}
                                      </option>
                                    ))}
                                  </CustomSelect>
                                </div>
                                <div className="col-md-2">
                                  <CustomInput
                                    name={`newlyUpdates[${index}].updatedAt`}
                                    type="date"
                                    placeholder="Date"
                                  />
                                </div>
                                <div className="col-md-2">
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </button>
                                </div>
                                <hr className="m-2" />
                              </div>
                            ))}
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={() =>
                                push({
                                  update: "",
                                  updatedBy: "",
                                  updatedAt: "",
                                })
                              }
                            >
                              Add Update
                            </button>
                          </div>
                        )}
                      </FieldArray>
                      {/* Subfeatures */}
                      <FieldArray name="subFeature">
                        {({ push, remove }) => (
                          <div>
                            <hr />
                            <h3>subFeatures</h3>
                            <hr />
                            {props.values.subFeature?.map((sub, index) => (
                              <div
                                key={index}
                                className="mb-2 align-items-center"
                              >
                                <div className="mb-2 row g-3 align-items-center">
                                  <div className="col-md">
                                    <CustomInput
                                      name={`subFeature[${index}].feature`}
                                      placeholder="Feature"
                                    />{" "}
                                  </div>
                                  <div className="col-md">
                                    <CustomInput
                                      name={`subFeature[${index}].description`}
                                      placeholder="Description"
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <CustomSelect
                                      name={`subFeature[${index}].createdBy`}
                                    >
                                      <option value="">Created By</option>
                                      {users?.map((user) => (
                                        <option
                                          key={user._id}
                                          value={user.nameName}
                                        >
                                          {user.userName}
                                        </option>
                                      ))}
                                    </CustomSelect>
                                  </div>
                                  <div className="col-md-2">
                                    <CustomInput
                                      name={`subFeature[${index}].date`}
                                      type="date"
                                      placeholder="Date"
                                    />
                                  </div>
                                </div>
                                <div className="mb-2 row g-3 align-items-center">
                                  <div className="col-md">
                                    <CustomInput
                                      name={`subFeature[${index}].accessRoute`}
                                      placeholder="Access Route"
                                    />{" "}
                                  </div>
                                  <div
                                    className="col-md border mt-3 px-2 pt-2"
                                    style={{
                                      maxHeight: "80px",
                                      overflow: "scroll",
                                    }}
                                  >
                                    {rolesList.map((role, index2) => (
                                      <div key={index2}>
                                        <div className="d-flex">
                                          <label className="form-check-inline">
                                            <CustomCheckbox
                                              type="checkbox"
                                              width="15px"
                                              height="15px"
                                              name={`subFeature[${index}].accessRoles`}
                                              value={role}
                                            />
                                          </label>
                                          <span className="form-check-label">
                                            {role}
                                          </span>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                  <div className="col-md-3">
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      onClick={() => remove(index)}
                                    >
                                      Remove
                                    </button>
                                  </div>
                                </div>
                                <hr className="m-2" />
                              </div>
                            ))}
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={() =>
                                push({
                                  feature: "",
                                  description: "",
                                  createdBy: "",
                                  date: "",
                                  accessRoute: "",
                                  accessRoles: [],
                                })
                              }
                            >
                              Add subFeature
                            </button>
                          </div>
                        )}
                      </FieldArray>
                    </div>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        <FormSubmitButton buttonText="Submit Feature" />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
};

export default AddFeature;
